import { digitsEnToFa } from "persian-tools2";
import * as Yup from 'yup';

const nameAndLastName = (string) =>
    Yup.string()
        .trim()
        .min(3, `${string} شما کمتر از ${digitsEnToFa(3)} کارکتر میباشد.`)
        .max(40, `شما تنها مجاز به نوشتن ${digitsEnToFa(40)} کارکتر میباشید.`)
        .matches(/^[\u0600-\u06FF\s]+$/, {
            message: `لطفا ${string} خود را فارسی وارد کنید.`,
        })
        .nullable(true)
        .required(`لطفا ${string} خود را وارد کنید.`);

const validationSchema = Yup.object({
    firstName: nameAndLastName('نام'),
    lastName: nameAndLastName('نام خانوادگی'),
    // phone
    phoneNumber: Yup.string()
        .trim()
        .min(11, `شماره موبایل شما کمتر از ${digitsEnToFa(11)} رقم میباشد.`)
        .max(11, `شماره موبایل شما بیشتر از ${digitsEnToFa(11)} رقم میباشد.`)
        .matches(/^(09)\d{9}$/i, {
            message: `شماره موبایل باید با ${digitsEnToFa('09')} شروع شود.`,
        })
        .required('لطفا شماره موبایل خود را وارد کنید.'),

    // scanCenterName: Yup.string()
    //     .trim()
    //     .min(3, `نام مرکز اسکن کمتر از ${digitsEnToFa(3)} کارکتر میباشد.`)
    //     .max(40, `شما تنها مجاز به نوشتن ${digitsEnToFa(40)} کارکتر میباشید.`)
    //     .matches(/^[\u0600-\u06FF\s]+$/, {
    //         message: 'لطفا نام مرکز اسکن را فارسی وارد کنید.',
    //     })
    //     .nullable(true)
    //     .required('لطفا نام مرکز اسکن را وارد کنید.'),
    //
    // scanCenterAddress: Yup.string()
    //     .trim()
    //     .max(
    //         250,
    //         `شما تنها مجاز به نوشتن ${digitsEnToFa(250)} کارکتر میباشید.`
    //     ).matches(/^[\u0600-\u06FF\s]+$/, {
    //         message: 'لطفا آدرس مرکز اسکن را فارسی وارد کنید.',
    //     })
    //     .nullable(true),
    // cityId: Yup.object()
    //     .required('لطفا شهر خود را انتخاب کنید.'),
    // provinceId: Yup.object()
    //     .required('لطفا استان خود را انتخاب کنید.'),
});


export default validationSchema;


export const validationScanCenter = Yup.object({
    scanCenterName: Yup.string()
        .trim()
        .min(3, `نام مرکز اسکن کمتر از ${digitsEnToFa(3)} کارکتر میباشد.`)
        .max(40, `شما تنها مجاز به نوشتن ${digitsEnToFa(40)} کارکتر میباشید.`)
        .matches(/^[\u0600-\u06FF\s]+$/, {
            message: 'لطفا نام مرکز اسکن را فارسی وارد کنید.',
        })
        .nullable(true)
        .required('لطفا نام مرکز اسکن را وارد کنید.'),

    scanCenterAddress: Yup.string()
        .trim()
        .max(
            250,
            `شما تنها مجاز به نوشتن ${digitsEnToFa(250)} کارکتر میباشید.`
        ).nullable(true),
    cityId: Yup.object().nullable()
        .required('لطفا شهر خود را انتخاب کنید.'),
    provinceId: Yup.object().nullable()
        .required('لطفا استان خود را انتخاب کنید.'),
});

